import script from "./CafeView.vue?vue&type=script&setup=true&lang=js"
export * from "./CafeView.vue?vue&type=script&setup=true&lang=js"

import "./CafeView.vue?vue&type=style&index=0&id=9d9d445a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d9d445a"]])

export default __exports__